import React from 'react'
import PropTypes from 'prop-types'

const TableRow = ({ columnList, row, onRowClick, onRowDoubleClick, hiddenColumns }) => {
    return (
        <tr
            className="table-row"
            onClick={() => {
                if (onRowClick) {
                    onRowClick(row)
                }
            }}
            onDoubleClick={() => {
                if (onRowDoubleClick) {
                    onRowDoubleClick(row)
                }
            }}>
            {columnList
                .filter(column => !hiddenColumns.includes(column.property))
                .map(({ property, renderer }) => {
                const value = renderer ? renderer(row, property) : row[property]
                return (<td key={property}>{value}</td>)
            })}
        </tr>)
}

TableRow.propTypes = {
    columnList: PropTypes.array.isRequired,
    row: PropTypes.object.isRequired,
    onRowClick: PropTypes.func,
    onRowDoubleClick: PropTypes.func,

}

export default TableRow



// WEBPACK FOOTER //
// ./src/modules/table/component/TableRow.js